<template>
  <div>
    <div class="photoContainer">
      <img src="frontImages/ibc48.jpg" class="topPhoto" />
    </div>

    <div class="separator"></div>

    <h1>{{$t('professionalServicesPage.h1')}}</h1>

    <div class="separator"></div>

    <b-list-group>
      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[0].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
          <ul>
            <li>{{$t('professionalServicesPage.table[0].des[0]')}}</li>
            <li>{{$t('professionalServicesPage.table[0].des[1]')}}</li>
            <li>{{$t('professionalServicesPage.table[0].des[2]')}}</li>
            <li>{{$t('professionalServicesPage.table[0].des[3]')}}</li>
          </ul>
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[1].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
          <ul>
            <li>{{$t('professionalServicesPage.table[1].des[0]')}}</li>
            <li>{{$t('professionalServicesPage.table[1].des[1]')}}</li>
            <li>{{$t('professionalServicesPage.table[1].des[2]')}}</li>
            <li>{{$t('professionalServicesPage.table[1].des[3]')}}</li>
            <li>{{$t('professionalServicesPage.table[1].des[4]')}}</li>
          </ul>
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[2].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[2].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[3].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[3].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[4].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[4].text")}}

        <ul class="withBullet">
          <li>{{$t("professionalServicesPage.table[4].des[0]")}}</li>
          <li>{{$t("professionalServicesPage.table[4].des[1]")}}</li>
          <li>{{$t("professionalServicesPage.table[4].des[2]")}}</li>
          <li>{{$t("professionalServicesPage.table[4].des[3]")}}</li>
        </ul>
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[5].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[5].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[6].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[6].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[7].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[7].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[8].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[8].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[9].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[9].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[10].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        {{$t("professionalServicesPage.table[10].des")}}
        </p>
      </b-list-group-item>

      <b-list-group-item href="#" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1"><font-awesome-icon
        :icon="['far', 'check-circle']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />{{$t("professionalServicesPage.table[11].title")}}</h5>
        </div>

        <p
          class="mb-1"
        >
        <ul class="withBullet">
          <li>{{$t("professionalServicesPage.table[11].des[0]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[1]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[2]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[3]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[4]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[5]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[6]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[7]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[8]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[9]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[10]")}}</li>
          <li>{{$t("professionalServicesPage.table[11].des[11]")}}</li>
        </ul>
        </p>
      </b-list-group-item>
    </b-list-group>

    <div class="separator"></div>
    <p class="text">{{$t("professionalServicesPage.remarks")}}</p>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
</script>

<style scoped>
  h1 {
    font-family: "Lato", sans-serif;
    font-weight: 500;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .withBullet {
    list-style: circle;
    margin-top: 1rem;
    margin-left: 1rem;
  }

  .withBullet > li {
    text-align: left;
  }

  ul li {
    text-align: left;
  }

  .mb-1 {
    padding-left: 2rem;
    margin-top: 1rem;
    text-align: left;
  }
</style>